import React, { FC, useState, useEffect, PropsWithChildren, useContext } from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

import './styles/fonts/font.css';
import Login from './components/auth/login';
import { reactNativeWindow } from './utils/get-native-window';
import Share from './components/share';
import { useOnGoBack } from './hooks/react-native/use-go-back';
import { VisitGuidesContextProvider } from './contexts/visit-guides';
import { ErrorBoundary } from './components/error-boundary/error-boundary';
import { RNQueryContextProvider } from './contexts/rn-query';
import { RNAppVersionContextProvider } from './contexts/rn-app-version';
import { Layout } from './components/common/layout';
import { ProfileContext } from './contexts/profile';
import { useApi } from './hooks';

type AppProps = PropsWithChildren;

const App: FC<AppProps> = ({ children }) => {
  const [authCheck, setAuthCheck] = useState(false);

  const { profile, setProfile } = useContext(ProfileContext);
  const api = useApi();
  
  useOnGoBack();

  useEffect(() => {
    setAuthCheck(false);
    api.profile.getProfile().then((response) => {
      if (response?.code !== 200) {
        setAuthCheck(true);
        return;
      }
      setProfile(response?.data);
      setAuthCheck(true);
    });
  }, []);

  const onLogin = async () => {
    api.profile.getProfile().then(({ code, data }) => {
      if (code !== 200) {
        setAuthCheck(false);
        return;
      }
      setProfile(data);
    });
  };

  return (
    <ErrorBoundary>
      <RNQueryContextProvider>
        <RNAppVersionContextProvider onLogin={onLogin} >
          <VisitGuidesContextProvider>
            {location.pathname.includes('/share') ? (
              <Share />
            ) : (
              <>
                {!authCheck && (
                  <Flex w='100vw' h='100vh' alignItems='center' justify='center' ><Spinner /></Flex>
                )}
                {authCheck && !profile && !reactNativeWindow.isNativeApp && (
                  <Login onLogin={onLogin} />
                )}
                {authCheck && profile && (
                  <Layout 
                    loading={false}
                    hideHeaderAndMenu={window.hideHeaderAndMenu}
                  >
                    {children}
                  </Layout>
                )}
              </>
            )}
          </VisitGuidesContextProvider>
        </RNAppVersionContextProvider>
      </RNQueryContextProvider>
    </ErrorBoundary>
  );
};

export default App;
